'use client';

import classNames from 'classnames';
import { IconArrowUp1 } from '@/features/icons';
import { BACK_TO_TOP_BUTTON_VISIBILITY_SCROLL_THRESHOLD } from '@/components/constants';
import { useScroll } from '@/utils/use-scroll';
const BackToTopButton = () => {
  const {
    isScrollingUp,
    scrollY
  } = useScroll();
  const scrollThreshold = typeof window !== 'undefined' ? window.screen.availHeight * BACK_TO_TOP_BUTTON_VISIBILITY_SCROLL_THRESHOLD : 0;
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <button onClick={scrollToTop} aria-label='back-to-top' className={classNames('md:duration-400 fixed right-1/2 top-0 z-20 box-border flex h-9 translate-x-1/2 transform items-center justify-center rounded-full border border-slate-300 bg-white bg-opacity-80 px-10 text-xs text-black shadow-sm outline-none transition-all duration-500 ease-in-out', scrollY > scrollThreshold ? 'flex translate-y-16 opacity-95 md:translate-y-20' : '-translate-y-20 opacity-0', isScrollingUp ? 'lg:top-16' : 'lg:-top-16')} data-sentry-component="BackToTopButton" data-sentry-source-file="back-to-top.tsx">
            <IconArrowUp1 className='h-4 w-4 text-slate-500' data-sentry-element="IconArrowUp1" data-sentry-source-file="back-to-top.tsx" />
        </button>;
};
export default BackToTopButton;